// extracted by mini-css-extract-plugin
export default {"container":"QV-z","title":"RV-z","link":"SV-z"};